import React, { FC } from 'react';
import { Table } from 'react-bootstrap';
import MemberRow from './MemberRow';
import { User } from '../../../../api/src/interfaces/shared';

interface Props {
  members: User[];
  onMemberClick: (member: User) => void;
}

const MemberTable: FC<Props> = ({ onMemberClick, members }) => (
  <div className="box">
    <div className="header">
      <h2> Medlemmer </h2>
    </div>
    <p className="row-info">
      Klikk på en bruker for å se portefølje og statistikk.
    </p>
    <Table hover responsive className="member-table" size="sm">
      <thead>
        <tr>
          <th />
          <th />
        </tr>
      </thead>
      <tbody>
        {members.map(member => (
          <MemberRow
            key={member.id}
            member={member}
            onMemberClick={() => onMemberClick(member)}
          />
        ))}
        <tr className="if-no-results">
          <td colSpan={2}>Ingen medlemmer funnet..</td>
        </tr>
      </tbody>
    </Table>
  </div>
);

export default MemberTable;
